import { useState } from 'react';
import { ApiError, apiFetch } from '../lib/api';
import type { TournamentDetail } from './useScoringTournament';

/** Admin switch for event-day mode. Off is the default and stores NULL. */
export function useEventDayToggle(
  detail: TournamentDetail | null,
  setDetail: (update: (current: TournamentDetail) => TournamentDetail) => void,
): { eventDay: boolean; busy: boolean; error: string | null; toggle: () => void } {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const eventDay = detail?.eventDay === true;

  function toggle() {
    if (!detail || busy) return;
    const next = !eventDay;
    setBusy(true);
    setError(null);
    void apiFetch<{ eventDay: boolean }>(`/api/admin/shooting/tournaments/${detail.tournament.id}/event-day`, {
      method: 'PATCH',
      body: JSON.stringify({ enabled: next }),
    })
      .then((body) => {
        setDetail((current) => ({ ...current, eventDay: body.eventDay }));
      })
      .catch((err: unknown) => {
        setError(err instanceof ApiError ? err.message : 'Could not change event day.');
      })
      .finally(() => setBusy(false));
  }

  return { eventDay, busy, error, toggle };
}
